import {useTranslation} from "react-i18next";

export const requestStatus = () => {
  const {t} = useTranslation();

  return [
    {id: "NEW", name: t('request.status.new'), className: "is-success"},
    {id: "PROCESSED", name: t('request.status.processed'), className: "is-warning"},
    {id: "DELETED", name: t('request.status.deleted'), className: "is-danger"}
  ];
}
